import { Component } from '@angular/core';
import { LayoutSelectors } from '@gestor-web/@core/store/selectors';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

// CSS: src\assets\sass\layout\menu\_menu_common.scss
// Data: { SIDEBAR_MENU } from '@gestor-web/@core/menu';

/**
 * @deprecated Não está mais sendo usado, ver componente 'app-inline-menu'
 */
@Component({
    selector: 'app-menu',
    template: `
    <ul class="layout-menu">
      @for (item of menu$ | async; track item; let i = $index) {
        <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
      }
    </ul>
    `,
    standalone: false
})
export class AppMenuComponent {
  menu$: Observable<any[]>; // = this.store.select(LayoutSelectors.selectLayoutMenu);
  constructor(private store: Store) {}
}
